import { useTranslation } from 'react-i18next';

import { Pencil } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { env } from '@/constants/env';

import { CollapsableCard } from './collapsable-card';

interface ImagePreviewProps {
  imageId: string;
  onReplace: () => void;
}

export const ImagePreview = ({ imageId, onReplace }: ImagePreviewProps) => {
  const { t } = useTranslation();

  return (
    <CollapsableCard title={t('yourRoom')}>
      <div className="flex flex-row flex-wrap items-center justify-center gap-2 sm:flex-col">
        <img
          className="h-32 rounded-sm object-cover lg:h-48"
          src={`${env.API_URL}/images/${imageId}`}
        />
        <Button
          className="relative w-full flex-1 border border-solid border-primary-light bg-white py-1 text-xs text-primary-light lg:w-auto lg:text-base"
          onClick={onReplace}
        >
          {t('replace')}
          <Pencil className="ml-2 !w-[14px]" />
        </Button>
      </div>
    </CollapsableCard>
  );
};
